// Get the text layer out of a PDF bank statement by asking our backend
// (server-side pdf-parse). Digital statements (FNB, Standard Bank, ABSA, etc.)
// carry a real text layer, so this is lossless — unlike handing the PDF image to
// the model, which silently drops lines on dense statements.
import { authHeader } from './firebase';

const BASE = process.env.REACT_APP_ENGINE_URL ?? 'http://localhost:3001';

export async function extractPdfText(pdfBase64) {
  const res = await fetch(BASE + '/api/pdf-text', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(await authHeader()) },
    body: JSON.stringify({ pdfBase64 }),
  });
  if (!res.ok) {
    const err = await res.text();
    throw new Error('PDF text extraction failed (' + res.status + '): ' + err.slice(0, 200));
  }
  const data = await res.json();
  return { text: data.text || '', pages: data.pages || null };
}
